import React, { useEffect, useState } from "react";
import { Col, Row, Spinner, Image, Button, Form } from "react-bootstrap";
import { LoadScript } from "@react-google-maps/api";

import AppNavbar from "../../components/common/AppNavbar";

const apiKey = "AIzaSyCpAApH1S5ZOOJsKcdGBV41KvRj2v3xndc";

const libraries = ["places"];

const CityDetail = () => {
  const [input, setInput] = useState("");
  const [cityName, setCityName] = useState("");
  const [places, setPlaces] = useState([]);
  const [shrines, setShrines] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isCountry, setIsCountry] = useState(null);
  const [countryTouristPlaces, setCountryTouristPlaces] = useState([]);

  const checkIfCountry = (placeResults) => {
    if (!placeResults || placeResults.length === 0) return false;
    return placeResults[0].types.includes("country");
  };

  const fetchTouristPlacesInCountry = (countryName, map, service) => {
    setLoading(true);
    const request = {
      location: map.getCenter(),
      radius: 50000,
      keyword: "tourist attractions",
      type: "tourist_attraction",
    };
    service.nearbySearch(request, (results, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        setCountryTouristPlaces(results.slice(0, 10));
      } else {
        setCountryTouristPlaces([]);
      }
      setLoading(false);
    });
  };

  const fetchDetailData = (placeName, map, center) => {
    setLoading(true);
    const service = new window.google.maps.places.PlacesService(map);

    const search = (keyword, setter) => {
      const request = { location: center, radius: 20000, keyword };
      service.nearbySearch(request, (results, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          const filtered = results.filter(
            (item) => item.photos && item.photos.length > 0
          );
          setter(filtered.slice(0, 8));
        } else {
          setter([]);
        }
        setLoading(false);
      });
    };

    search(`tourist places in ${placeName}`, setPlaces);
    search(`temples in ${placeName}`, setShrines);
    search(`fine dining in ${placeName}`, setRestaurants);
  };

  const handleSearch = () => {
    if (!input.trim()) return;
    setLoading(true);
    setCityName("");
    setIsCountry(null);
    setCountryTouristPlaces([]);
    setPlaces([]);
    setShrines([]);
    setRestaurants([]);

    const map = new window.google.maps.Map(document.createElement("div"));
    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address: input.trim() }, (results, status) => {
      if (status === "OK" && results.length > 0) {
        const location = results[0].geometry.location;
        map.setCenter(location);

        const isCountryResult = checkIfCountry(results);
        setIsCountry(isCountryResult);

        if (isCountryResult) {
          // Show tourist places in country
          const service = new window.google.maps.places.PlacesService(map);
          fetchTouristPlacesInCountry(input.trim(), map, service);
          setLoading(false);
        } else {
          // Show detailed UI for place
          setCityName(input.trim());
          fetchDetailData(input.trim(), map, location);
        }
      } else {
        alert("Location not found. Please enter a valid country or place.");
        setLoading(false);
      }
    });
  };

  // When user clicks a tourist place from country list
  const handlePlaceClick = (place) => {
    setCityName(place.name);
    setIsCountry(false);
    setLoading(true);

    const map = new window.google.maps.Map(document.createElement("div"));
    map.setCenter(place.geometry.location);

    fetchDetailData(place.name, map, place.geometry.location);
  };

  const renderCardGrid = (title, data, clickable = false) =>
    data.length > 0 && (
      <div className="py-4">
        <h3 className="my-4 fw-bold">{title}</h3>
        <Row>
          {data.map((item, index) => (
            <Col
              key={index}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="mb-4"
              style={{ cursor: clickable ? "pointer" : "default" }}
              onClick={() => clickable && handlePlaceClick(item)}
            >
              <div className="yacht-tile">
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    item.name +
                      " " +
                      (item.vicinity || item.formatted_address || "")
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                  onClick={(e) => clickable && e.preventDefault()}
                >
                  <img
                    src={item.photos?.[0]?.getUrl() || ""}
                    alt={item.name}
                    className="img-fluid rounded"
                  />
                  <div className="overlay mt-2">
                    <h5>{item.name}</h5>
                  </div>
                </a>
              </div>
              <p className="text-muted small">
                {item.vicinity || item.formatted_address}
              </p>
            </Col>
          ))}
        </Row>
      </div>
    );

  return (
    <>
      <AppNavbar />

      <LoadScript googleMapsApiKey={apiKey} libraries={libraries}>
        <div className="container py-4">
          <Row className="mb-4">
            <Col xs={12} md={8}>
              <Form.Control
                type="text"
                placeholder="Enter a country or city name"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              />
            </Col>
            <Col xs={12} md={4}>
              <Button
                variant="primary"
                onClick={handleSearch}
                className="w-100"
                disabled={loading}
              >
                Search
              </Button>
            </Col>
          </Row>

          {/* If country detected & tourist places list is ready */}
          {isCountry && (
            <>
              <h2 className="mb-4">Top Tourist Places in {input.trim()}</h2>
              {loading && (
                <div className="text-center py-5">
                  <Spinner animation="border" />
                  <p>Loading tourist places...</p>
                </div>
              )}
              {!loading &&
                renderCardGrid(
                  "Top Tourist Places",
                  countryTouristPlaces,
                  true
                )}
            </>
          )}

          {/* Show detail UI if non-country or user clicked place */}
          {!isCountry && cityName && (
            <>
              <h4 className="fw-bold">
                Discover {cityName}'s Local Attractions, Holy Shrines, and Fine
                Dining Restaurants
              </h4>
              <p>
                {cityName} is a vibrant destination rich in culture,
                spirituality, and food. Explore below.
              </p>

              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" />
                  <p>Loading data for {cityName}...</p>
                </div>
              ) : (
                <>
                  {renderCardGrid("Local Attractions", places)}

                  <small className="text-center d-block mb-3">
                    Advertisement
                  </small>
                  <Image
                    src="https://platforms.makemytrip.com/contents/16b311c3-7539-4380-a655-e47dc48e1f49"
                    alt="Ad"
                    fluid
                    className="rounded"
                  />

                  <hr />

                  {renderCardGrid("Holy Shrines", shrines)}

                  <small className="text-center d-block mb-3">
                    Advertisement
                  </small>
                  <Image
                    src="https://platforms.makemytrip.com/contents/16b311c3-7539-4380-a655-e47dc48e1f49"
                    alt="Ad"
                    fluid
                    className="rounded"
                  />

                  <hr />

                  {renderCardGrid("Fine Dining Restaurants", restaurants)}

                  <small className="text-center d-block mb-3">
                    Advertisement
                  </small>
                  <Image
                    src="https://platforms.makemytrip.com/contents/16b311c3-7539-4380-a655-e47dc48e1f49"
                    alt="Ad"
                    fluid
                    className="rounded"
                  />
                </>
              )}
            </>
          )}
        </div>
      </LoadScript>
    </>
  );
};

export default CityDetail;
